import { DateTime } from 'luxon';
import { TEmVatCorrectionsImportRow } from 'redux/reducers/emVatCorrectionsImport/types';

const SCHEME_LABELS: Record<string, string> = {
	ioss: 'Import',
	non_eu_ioss: 'Non EU Import',
	non_union: 'Non-Union',
	union: 'Union',
};

export const getSchemeLabel = (scheme: string): string => SCHEME_LABELS[scheme] ?? scheme;

export const formatCommencementDate = (iso: string | null | undefined): string => {
	if (!iso) return '—';
	const dt = DateTime.fromISO(iso);
	return dt.isValid ? dt.toFormat('dd.MM.yyyy') : iso;
};

const formatMoney = (amount: number, currencyCode: string) =>
	new Intl.NumberFormat('en-US', {
		style: 'currency',
		currency: currencyCode,
	}).format(amount);

export type TVerificationCorrectionBanner = {
	visible: boolean;
	message: string;
};

export const getVerificationCorrectionBanner = (
	row: TEmVatCorrectionsImportRow,
): TVerificationCorrectionBanner => {
	const currencyCode = row.order_currency ?? 'EUR';
	const country = row.country;
	const map = row.last_reported_vat_per_ms;
	const requested = row.requested_value_correction;
	const deductibleAmount = requested * -1;

	if (!map || !Object.prototype.hasOwnProperty.call(map, country)) {
		return {
			visible: true,
			message: `Correction should be rejected! Deductible VAT amount ${formatMoney(
				deductibleAmount,
				currencyCode,
			)} is greater than the available for reimbursement from ${country} VAT amount: not reported for this member state.`,
		};
	}

	const available = map[country];
	if (deductibleAmount > available) {
		return {
			visible: true,
			message: `Correction should be rejected! Deductible VAT amount ${formatMoney(
				deductibleAmount,
				currencyCode,
			)} is greater than the available for reimbursement from ${country} VAT amount: ${formatMoney(
				available,
				currencyCode,
			)}`,
		};
	}

	return { visible: false, message: '' };
};
